import { eReducerStatusBase } from "../../page-state-model/eReducerStatusBase";
import { v4 as uuidv4 } from 'uuid';
import { IThuPhiReducer, IThuPhiTabReducer } from "../../page-state-model/IThuPhiTabReducer";
import { IThuPhiTabActionTypes } from "../../action-types/thu-phi-tabs/IThuPhiTabActionType";
const iniTab: IThuPhiTabReducer = {
    id: uuidv4(),
    title: "Untitled",
    step: 0,
    status: eReducerStatusBase.is_not_initialization,
    request: {
        ts_hocsinh_id: 0,
        nam_hoc: ''
    },
    categorySelectedId: 0,

}
const HOC_SINH_TAB_ID = "hoc-sinh";

const iniState: IThuPhiReducer = {
    selectedId: HOC_SINH_TAB_ID,
    tabs: []
}
export const thuPhiTabReducer = (state: IThuPhiReducer = iniState, action: IThuPhiTabActionTypes): IThuPhiReducer => {
    switch (action.type) {
        case "THU_PHI_TAB_ADD_NEW_TAB":
            const id = uuidv4();
            return {
                ...state,
                // Giữ nguyên selectedId hiện tại, không tự động chuyển sang tab mới
                selectedId: state.selectedId,
                tabs: [{ ...iniTab, id: id }, ...state.tabs]
            }
        case "THU_PHI_TAB_REMOVE_TAB":
            const tabToRemoveId = action.payload;
            const tabToRemoveIndex = state.tabs.findIndex(t => t.id === tabToRemoveId);
            const remainingTabs = state.tabs.filter(t => t.id !== tabToRemoveId);
            let newSelectedId: string;
            
            // Nếu không còn tab nào, luôn quay về màn hình học sinh
            if (remainingTabs.length === 0) {
                newSelectedId = HOC_SINH_TAB_ID;
            } 
            // Nếu tab đang chọn không phải là tab bị xóa, giữ nguyên
            else if (state.selectedId !== tabToRemoveId) {
                newSelectedId = state.selectedId;
            }
            // Nếu tab đang chọn bị xóa, chuyển về tab trước đó (giống logic khi thêm cùng học sinh)
            else {
                // Tìm tab trước đó trong mảng tabs gốc
                if (tabToRemoveIndex > 0) {
                    const previousTabId = state.tabs[tabToRemoveIndex - 1].id;
                    // Kiểm tra tab trước đó có còn trong remainingTabs không
                    if (remainingTabs.some(t => t.id === previousTabId)) {
                        newSelectedId = previousTabId;
                    } else if (remainingTabs.length > 0) {
                        // Nếu tab trước đó không còn, chuyển sang tab đầu tiên còn lại
                        newSelectedId = remainingTabs[0].id;
                    } else {
                        newSelectedId = HOC_SINH_TAB_ID;
                    }
                } else if (remainingTabs.length > 0) {
                    // Nếu không có tab trước đó (tab bị xóa là tab đầu tiên), chuyển sang tab đầu tiên còn lại
                    newSelectedId = remainingTabs[0].id;
                } else {
                    // Nếu không còn tab nào, quay về tab học sinh
                    newSelectedId = HOC_SINH_TAB_ID;
                }
            }
            
            return {
                ...state,
                tabs: remainingTabs,
                selectedId: newSelectedId
            }
        case "THU_PHI_TAB_UPDATE_TAB_DATA":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.id) {
                        return action.payload
                    }
                    return t;
                })
            }
        case "THU_PHI_TAB_CHANGEG_SELECTED_TAB":
            return {
                ...state,
                selectedId: action.payload
            }
        case "THU_PHI_TAB_CREATE_THUPHI_START":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_saving
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_CREATE_THUPHI_SUCCCESS":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            donHangId: action.payload.data,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_CREATE_THUPHI_ERROR":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_LOAD_THU_PHI_START":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_loading
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_LOAD_THU_PHI_SUCCESS":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            donHangs: action.payload.data,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        case "THU_PHI_TAB_LOAD_THU_PHI_ERROR":
            return {
                ...state,
                tabs: state.tabs.map(t => {
                    if (t.id === action.payload.tabId) {
                        return {
                            ...t,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return {
                        ...t
                    }
                })
            }
        default:
            return state;
    }
}